import { Injectable } from '@nestjs/common';
import { AssociatesResponse, CompanyIdRequest, DepartmentDropResponse, DepartmentModel, ErrorResponse, GlobalResponseObject, SchemaxDepartmentModel, SchemaxDepartmentResponse, SchemaxEmployeesModel, SchemaxEmployeesResponse } from '@schemax-whatsapp/shared-models';
import { SchemaxDbConnection } from '../db-connections/schemax-db-connection';
import { CompanyDeptRoleCategoryCodeRequest } from '../whatsapp-broad-cast/model/company-dept-role-cat.request';

@Injectable()
export class SchemaxInfoService {
    constructor(
        private dbConnectionService: SchemaxDbConnection
    ) { }

    async getSchemaxResources(req: CompanyDeptRoleCategoryCodeRequest): Promise<SchemaxEmployeesResponse> {
        const dbConnection = await this.dbConnectionService.getSchemaxDbConnection('SCX');
        let employeeQuery = '';
        if(req.departmentCode) {
            employeeQuery = `SELECT CONCAT(e.first_name , e.last_name) AS employeeName , e.employee_code AS employeeCode , e.contact_number AS contactNumber 
            FROM tasktracker.employee_info e
            LEFT JOIN tasktracker.user u ON e.user_id = u.id
            WHERE  u.status = '10' AND e.department = ${req.departmentCode} `;
        } else {
            employeeQuery = `SELECT CONCAT(e.first_name , e.last_name) AS employeeName , e.employee_code AS employeeCode , e.contact_number AS contactNumber 
            FROM tasktracker.employee_info e
            LEFT JOIN tasktracker.user u ON e.user_id = u.id
            WHERE  u.status = '10' `;
        }
        const data = await dbConnection.query(employeeQuery);
        dbConnection.close();
        if (data.length == 0) {
            throw new ErrorResponse(0, 'Schemax resources not found');
        }
        const response = new SchemaxEmployeesResponse(true, 1111, 'Data retrieved successfully', data);
        return response;
    }

    async getSchemaxVendors(): Promise<SchemaxEmployeesResponse> {
        const schemaxEmpModel: SchemaxEmployeesModel[] = [];
        const dbConnection = await this.dbConnectionService.getSchemaxDbConnection('SCX');
        let vendorsQuery =  "SELECT vendor_name, vendor_code, contact_number FROM tasktracker.vendors WHERE vendor_status = 'Active' ";
        const data: {vendor_name: string, vendor_code: string, contact_number: string}[] = await dbConnection.query(vendorsQuery);
        dbConnection.close();
        if (data.length == 0) {
            throw new ErrorResponse(0, 'Schemax vendors not found');
        }
        data.forEach(rec => {
            schemaxEmpModel.push(new SchemaxEmployeesModel(rec.vendor_code, rec.vendor_name, rec.contact_number));
        })
        const response = new SchemaxEmployeesResponse(true, 1111, 'Data retrieved successfully', schemaxEmpModel);
        return response;
    }

    async getSchemaxCustomers(): Promise<SchemaxEmployeesResponse> {
        const schemaxEmpModel: SchemaxEmployeesModel[] = [];
        const dbConnection = await this.dbConnectionService.getSchemaxDbConnection('SCX');
        let clientsQuery =  "SELECT client_name, client_code, phone_no FROM tasktracker.clients_master WHERE client_status = 'Active' ";
        const data: {client_name: string, client_code: string, phone_no: string}[] = await dbConnection.query(clientsQuery);
        dbConnection.close();
        if (data.length == 0) {
            throw new ErrorResponse(0, 'Schemax customers not found');
        }
        data.forEach(rec => {
            schemaxEmpModel.push(new SchemaxEmployeesModel(rec.client_code, rec.client_name, rec.phone_no));
        })
        const response = new SchemaxEmployeesResponse(true, 1111, 'Data retrieved successfully', schemaxEmpModel);
        return response;
    }

    async getSchemaxDepartments(): Promise<SchemaxDepartmentResponse> { 
        const departments: SchemaxDepartmentModel[] = [];
        const dbConnection = await this.dbConnectionService.getSchemaxDbConnection('SCX');
        const deptQuery = "SELECT id, department_name FROM tasktracker.`departments_master` WHERE department_status = 'Active' ";
        const data: {id: string, department_name: string}[] = await dbConnection.query(deptQuery);
        dbConnection.close();
        if (data.length == 0) {
            throw new ErrorResponse(0, 'Schemax departments not found');
        }
        data.forEach(rec => {
            departments.push(new SchemaxDepartmentModel(rec.department_name, rec.department_name, rec.id));
        });
        return new SchemaxDepartmentResponse(true, 0, 'Departments retrieved successfully', departments);
    }
}
